import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  focus: any;
  focus1: any;
  constructor() { }

  ngOnInit(): void {
  }

}
